import Api from '../utilities/api';
import { triggerIdA } from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class DashboardAccess {
    static getDailyDashboard = (clientId, date) => Api.post('_Dashboard_DailyDashboard', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId
        },
        {
          name: 'slctdDate',
          value: date
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    });

    static getWeeklyDashboard = (clientId, startDate, endDate) => Api.post('_Dashboard_WeeklyDashboard', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId
        },
        {
          name: 'StartDate',
          value: startDate
        },
        {
          name: 'EndDate',
          value: endDate
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    });
}
